import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  regionCoordinates: [],
  hoveredProperty: null,
  selectedMiniCardData: {},
  commuteShape: null,
  isDrawingMode: false,
  isFallbackMode: false,
  userLocationEnabled: false,
  searchWithinMapWindow: true,
  setSearchWithinAsPreference: true,
  viewBounds: null,
  searchResultsLastKnownBounds: null,
  shouldFitBoundsOnMapOnly: false,
  shouldFitToProperties: false,
  layerVisibilityPanelOpen: false,
  legendPanelOpen: false,
  statusFiltersPanelOpen: false,
  parcelInfoPanelOpen: false,
  layerVisibility: {
    search: {
      parcel: true,
      flood: false,
      afb: false
    },
    taxDetail: {
      parcel: true,
      flood: false,
      afb: false
    }
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_REGION_COORDINATES:
      return {
        ...state,
        regionCoordinates: action.coordinates
      }
    case actionTypes.CLEAR_REGION_COORDINATES:
      return {
        ...state,
        regionCoordinates: []
      }
    case actionTypes.SET_HOVERED_PROPERTY:
      return {
        ...state,
        hoveredProperty: action.property
      }
    case actionTypes.SET_SELECTED_MINI_CARD_DATA:
      return {
        ...state,
        selectedMiniCardData: {
          upi: action.upi,
          activityData: action.activityData
        }
      }
    case actionTypes.SET_COMMUTE_SHAPE:
      return {
        ...state,
        commuteShape: action.commuteShape
      }
    case actionTypes.SET_USER_LOCATION_ENABLED:
      return {
        ...state,
        userLocationEnabled: action.bool
      }
    case actionTypes.SEARCH_WITHIN_MAP_WINDOW:
      return {
        ...state,
        searchWithinMapWindow: action.bool
      }
    case actionTypes.SET_SEARCH_WITHIN_AS_PREFERENCE:
      return {
        ...state,
        setSearchWithinAsPreference: action.bool
      }
    case actionTypes.SET_BOUNDS:
      return {
        ...state,
        viewBounds: action.bounds
      }
    case actionTypes.SET_SHOULD_FIT_BOUNDS_ON_MAP_ONLY:
      return {
        ...state,
        shouldFitBoundsOnMapOnly: action.bool
      }
    case actionTypes.SET_SHOULD_FIT_TO_PROPERTIES:
      return {
        ...state,
        shouldFitToProperties: action.bool
      }
    case actionTypes.RESET_FILTERS:
      return {
        ...state,
        commuteShape: null
      }
    case actionTypes.SEARCH_LAYERS_VISIBILITY:
      return {
        ...state,
        layerVisibility: {
          ...state.layerVisibility,
          search: action.layers
        }
      }
    case actionTypes.TAX_DETAIL_LAYERS_VISIBILITY:
      return {
        ...state,
        layerVisibility: {
          ...state.layerVisibility,
          taxDetail: action.layers
        }
      }
    case actionTypes.TOGGLE_LAYER_VISIBILITY_PANEL:
      return {
        ...state,
        layerVisibilityPanelOpen: action.bool
      }
    case actionTypes.TOGGLE_LEGEND_PANEL:
      return {
        ...state,
        legendPanelOpen: action.bool
      }
    case actionTypes.TOGGLE_STATUS_FILTERS_PANEL:
      return {
        ...state,
        statusFiltersPanelOpen: action.bool
      }
    case actionTypes.TOGGLE_PARCEL_INFO_PANEL:
      return {
        ...state,
        parcelInfoPanelOpen: action.bool
      }
    case actionTypes.SET_DRAWING_MODE:
      return {
        ...state,
        isDrawingMode: action.isDrawingMode
      }
    case actionTypes.SET_MAP_FALLBACK_MODE:
      return {
        ...state,
        isFallbackMode: action.isFallbackMode
      }
    default:
      return state
  }
}

export default reducer
